import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CertificateNote_Interface, Empty_CertificateNote_Interface } from 'src/app/Interface/CertificateNote_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CertificateNoteService } from 'src/app/Service/CertificateNote/CertificateNote.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CertificateNoteList',
  templateUrl: './CertificateNoteList.component.html',
  styleUrls: ['./CertificateNoteList.component.scss']
})
export class CertificateNoteListComponent implements OnInit {

  Token:String=""
  Filter_code:string=""
  Filter_dsc:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private CertificateNote_Service:CertificateNoteService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_CertificateNote:Array<CertificateNote_Interface>=[]
  Data_Seleted_Delete:CertificateNote_Interface=Empty_CertificateNote_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,2212).subscribe(
      data=>{
        this.ReadData_CertificateNote()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

    
  }

  ReadData_CertificateNote(){
    this.Procssing=true
    this.CertificateNote_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_CertificateNote=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:CertificateNote_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.CertificateNote_Service.DeleteCertificateNote(item.id,this.Token).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully")
        this.ReadData_CertificateNote()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
